import { useEffect } from 'react';

import { getQueryParamSingleValue } from 'src/lib/browser';
import { useHistory } from 'src/lib/hooks';
import { ROUTE_PARAMS, ROUTES } from 'src/routes';

import { MainStoreContainer } from './store/main';
import { View } from './View';

const getAuthorizeUrl = (): string | undefined =>
  getQueryParamSingleValue(ROUTE_PARAMS.oauth2Consent) ||
  getQueryParamSingleValue(ROUTE_PARAMS.returnTo);

export const Container = () => {
  const history = useHistory();
  const authorizeUrl = getAuthorizeUrl();

  useEffect(() => {
    if (!authorizeUrl) {
      history.replace(ROUTES.ROOT);
    }
  }, [authorizeUrl, history]);

  if (!authorizeUrl) {
    return null;
  }

  return (
    <MainStoreContainer authorizeUrl={authorizeUrl}>
      <View />
    </MainStoreContainer>
  );
};
